import { render, staticRenderFns } from "./CorrectionDetail.vue?vue&type=template&id=702818c4&"
import script from "./CorrectionDetail.vue?vue&type=script&lang=js&"
export * from "./CorrectionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports